document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-slick-container]').forEach(function (container) {
    const sectionId = container.dataset.slickContainer;
    const autoplay = container.dataset.slickAutoplay === 'true';

    const slickTarget = document.querySelector('.quotes-2-' + sectionId);

    function initSlickWhenReady() {
      if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined' && slickTarget) {
        jQuery(slickTarget).slick({
          dots: false,
          infinite: false,
          arrows: false,
          autoplay: autoplay,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else {
        setTimeout(initSlickWhenReady, 50);
      }
    }

    initSlickWhenReady();
  });
});
